import dayjs from 'dayjs';

import { AvProxyApi } from '@availity/api-axios';
import transactions from '../api/anthem/api-anthem';

import commonStore from '../stores/CommonStore';

// Create an instance of AvProxyApi
const transactionProxy = new AvProxyApi({
  tenant: 'anthem',
  name: 'v1/providerapp/logging/transactions',
});

const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

const JSONParser = (data = {}) => {
  const htmlPattern = /<.*?>/;
  const sanitizeAndProcessRecursiveFn = (value) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          value[key] = sanitizeAndProcessRecursiveFn(value[key]);
        }
      }
    } else if (Array.isArray(value)) {
      return value.map((item) => sanitizeAndProcessRecursiveFn(item));
    } else if (value && typeof value === 'string' && htmlPattern.test(value)) {
      return '';
    }
    return value;
  };

  return sanitizeAndProcessRecursiveFn(data);
};

transactionProxy.http.interceptors.request.use((request) => {
  try {
    // Modify the requests only for Anthem Service Calls
    if (
      request &&
      request.api &&
      request.url &&
      request.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
      request.url !== '/api/v1/proxy/anthem/v1/providerapp/reportanincident.config'
    ) {
      const { userAndBrand, config } = commonStore;
      const { transactionPrefix: prefix } = config.payLoadData; // Accessing payLoadData from default import
      const { brand } = userAndBrand;
      const { code } = brand;
      const transactionPrefix = `${code}${prefix}`; // Corrected concatenation
      // add transaction prefix for all service calls to generate trans ID
      request.headers['X-Availity-Transaction-Prefix'] = transactionPrefix;
      // add request sent time for the service to calculate E2E time taken
      request.headers['meta-request-sent-time'] = dayjs().format();
    }
  } catch (error) {
    window.console.log(error);
  }
  return request;
});

transactionProxy.http.interceptors.response.use(
  (response) => {
    let requestParams = '';
    try {
      // Modify the requests only for Anthem Service Calls
      if (
        response.config &&
        response.config.api &&
        response.config.url &&
        response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
        response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/reportanincident.config' &&
        response.config.url.toLowerCase().indexOf('anthem') > -1
      ) {
        const { userAndBrand, config } = commonStore;
        const { appName, channel, transactionPrefix } = config.payLoadData; // Accessing payLoadData from default import
        const { user, brand } = userAndBrand;
        const { interactionId, id } = user;
        const { state, payerName, code } = brand;

        let transactionId = response.headers['meta-transid'];
        if (!transactionId) {
          transactionId = `${transactionPrefix}${code}-${appName}`;
        }
        const queryParameters = {
          state,
          payer: payerName,
          brand: code,
          userId: id,
          appName,
          channel,
          transactionId,
          interactionId,
          httpStatus: response.status,
          reqSentTime: response.config.headers['meta-request-sent-time'],
          respRcptTime: dayjs().format(),
          requestType: response.config.method,
          operationName: response.config.url,
        };
        if (response.config.params) {
          const isJson = typeof response.config.params === 'object';
          requestParams = isJson ? response.config.params : JSON.parse(response.config.params);
        }
        if (response.config.data) {
          const isJson = typeof response.config.data === 'object';
          requestParams = isJson ? response.config.data : JSON.parse(response.config.data);
        }
        const responseObj = deepClone(response.data);
        const requestObj = deepClone(requestParams);

        const requestJSON = JSONParser(requestObj);
        const responseJSON = JSONParser(responseObj);
        const payLoad = {
          requestString: requestJSON,
          requestHeaders: response.config.headers,
          responseString: responseJSON,
        };
        transactions({ metaData: queryParameters, payload: payLoad });
      }
    } catch {
      // Modify the requests only for Anthem Service Calls
      if (
        response.config &&
        response.config.api &&
        response.config.url &&
        response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
        response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/reportanincident.config' &&
        response.config.url.toLowerCase().indexOf('anthem') > -1
      ) {
        const { userAndBrand, config } = commonStore;
        const { appName, channel, transactionPrefix } = config.payLoadData; // Accessing payLoadData from default import
        const { user, brand } = userAndBrand;
        const { interactionId, id } = user;
        const { state, payerName, code } = brand;

        let transactionId = response.headers['meta-transid'];
        if (!transactionId) {
          transactionId = `${transactionPrefix}${code}-${appName}`;
        }
        const queryParameters = {
          state,
          payer: payerName,
          brand: code,
          userId: id,
          appName,
          channel,
          transactionId,
          interactionId,
          httpStatus: response.status,
          reqSentTime: response.config.headers['meta-request-sent-time'],
          respRcptTime: dayjs().format(),
          requestType: response.config.method,
          operationName: response.config.url,
        };
        let requestParam = '';
        if (response.config.params) {
          const isJson = typeof response.config.params === 'object';
          requestParam = isJson ? response.config.params : JSON.parse(response.config.params);
        }
        if (response.config.data) {
          const isJson = typeof response.config.data === 'object';
          requestParam = isJson ? response.config.data : JSON.parse(response.config.data);
        }
        const responseObj = deepClone(response.data);
        const requestObj = deepClone(requestParam);

        const requestJSON = JSONParser(requestObj);
        const responseJSON = JSONParser(responseObj);
        const payLoad = {
          requestString: requestJSON,
          requestHeaders: response.config.headers,
          responseString: responseJSON,
        };
        transactions({ metaData: queryParameters, payload: payLoad });
      }
    }
    return response;
  },
  (error) => {
    if (
      error.response.config &&
      error.response.config.api &&
      error.response.config.url &&
      error.response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/logging/transactions' &&
      error.response.config.url !== '/api/v1/proxy/anthem/v1/providerapp/reportanincident.config' &&
      error.response.config.url.toLowerCase().indexOf('anthem') > -1
    ) {
      const { userAndBrand, config } = commonStore;
      const { appName, channel, transactionPrefix } = config.payLoadData; // Accessing payLoadData from default import
      const { user, brand } = userAndBrand;
      const { interactionId, id } = user;
      const { state, payerName, code } = brand;

      let transactionId = error.response.headers['meta-transid'];
      if (!transactionId) {
        transactionId = `${transactionPrefix}${code}-${appName}`;
      }
      const queryParameters = {
        state,
        payer: payerName,
        brand: code,
        userId: id,
        appName,
        channel,
        transactionId,
        interactionId,
        httpStatus: error.response.status,
        reqSentTime: error.response.config.headers['meta-request-sent-time'],
        respRcptTime: dayjs().format(),
        requestType: error.response.config.method,
        operationName: error.response.config.url,
      };
      let requestParam = '';
      if (error.response.config.params) {
        const isJson = typeof error.response.config.params === 'object';
        requestParam = isJson ? error.response.config.params : JSON.parse(error.response.config.params);
      }
      if (error.response.config.data) {
        const isJson = typeof error.response.config.data === 'object';
        requestParam = isJson ? error.response.config.data : JSON.parse(error.response.config.data);
      }
      const responseObj = deepClone(error.response.data);
      const requestObj = deepClone(requestParam);

      const requestJSON = JSONParser(requestObj);
      const responseJSON = JSONParser(responseObj);
      const payLoad = {
        requestString: requestJSON,
        requestHeaders: error.response.config.headers,
        responseString: responseJSON,
      };
      transactions({ metaData: queryParameters, payload: payLoad });
    }
    return Promise.reject(error.response);
  }
);
